<template>
  <div v-loading="isLoading">
    <el-table
      :data="webhooks"
      stripe
    >
      <el-table-column
        label="Event"
        prop="event"
        :formatter="(row, col, cellValue) => getEventName(cellValue)"
      />

      <el-table-column
        label="Endpoint"
        prop="endpoint"
        show-overflow-tooltip
      />

      <el-table-column
        label="Created At"
        prop="created_at"
      />

      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
        width="190px"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canDelete"
            size="mini"
            @click.native="editWebhook(scope.$index, scope.row)"
          >
            Edit
          </el-button>

          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteWebhook(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Pagination -->
    <el-pagination
      class="text-center pt-3"
      :current-page.sync="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size.sync="perPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="loadTable"
      @current-change="loadTable"
    />

    <!-- Edit Form -->
    <WebhookEditForm
      v-if="isShowEditForm"
      ref="webhookEditFOrm"
      :is-show.sync="isShowEditForm"
      :webhook="webhook"
      :account-id="accountId"
      @saved="loadTable()"
    />
  </div>
</template>

<script>
import WebhookEditForm from '@/components/Application/Manage/Account/WebhookEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    WebhookEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      webhook: null,
      webhooks: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_team')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_team')
    }
  },
  created () {
    this.loadTable()
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_team'),
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.webhook = new this.$sdk.account_webhook()
          this.isShowEditForm = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account.read(this.accountId, builder => {
        builder.include = ['webhooks']
      })
        .then(account => { this.webhooks = account.webhooks })
        .finally(() => { this.isLoading = false })
    },
    editWebhook (index, row) {
      this.webhook = row.clone()
      this.isShowEditForm = true
    },
    deleteWebhook (index, row) {
      this.$confirm('Are you sure to delete this webhook?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    },
    getEventName (value) {
      switch (value) {
        case 'tracking-manifested':
          return 'Manifested'
        case 'tracking-onboardForDelivery':
          return 'Onboard for Delivery'
        case 'tracking-delivered':
          return 'Delivered'
        case 'tracking-proofOfDelivery':
          return 'Proof of Delivery'
        case 'tracking-error':
          return 'Error'
        case 'tracking-potentialProblem':
          return 'Potential Problem'
        case 'tracking-inTransitPossibleDelay':
          return 'In Transit Possible Delay'
        case 'tracking-inTransit':
          return 'In Transit'
        case 'tracking-pickedUp':
          return 'Picked Up'
        default:
          return value
      }
    }
  }
}
</script>

<style>

</style>
